import { render } from "./QuestionBadge.vue?vue&type=template&id=6265ea85&scoped=true"
import script from "./QuestionBadge.vue?vue&type=script&lang=js"
export * from "./QuestionBadge.vue?vue&type=script&lang=js"

import "./QuestionBadge.vue?vue&type=style&index=0&id=6265ea85&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6265ea85"]])

export default __exports__